import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-exception-modal',
    templateUrl: './exception-modal.component.html',
    styleUrls: ['./exception-modal.component.scss'],
    standalone: false
})
export class ExceptionModalComponent {
  private router = inject(Router);


  @Input() exceptionalModalFlag!: boolean;
  @Input() notifyText!: string;
  @Output() exceptionalModalEmit = new EventEmitter<any>();
  @Input() saveInvoice!:boolean ;
  @Input() saveAndUpdate!:boolean ;
  @Input() isSuccessNotify !:boolean ;

  public facilityId:any;

  constructor(){
    this.facilityId = sessionStorage?.getItem('headerFacilityId') || '';

  }


  get updateFlag(): boolean {
    return this.exceptionalModalFlag;
  }

  public closeModal(): void {
    this.exceptionalModalFlag = false;
    this.exceptionalModalEmit?.emit(false);
   // this.router.navigate(['/invoice/invoiceBoard']);
    if(this.saveInvoice == true || this.saveAndUpdate == true){
      this.router.navigate(['/invoice/invoiceBoard']);
    }
  }

}
